/**
 * 按钮组件配置
 */
const config = {
  id: 100,
  name: '按钮',
  type: 1,
  module_code: 'button',
  icon: 'icon-tms-anniu',
  font_icon: '&#xe6fc',
  style_type: 1,
  link_type: 0,
  property_data: {
    text: '按钮',
    button_type: 'primary',
    size: 'medium',
    shape: 'default',
    plain: false,
    loading: false,
    disabled: false,
    link: '',
    open_type: '_blank',
    margin_top: 10,
    margin_right: 10,
    margin_bottom: 10,
    margin_left: 10,
    alignment: 'left'
  }
};

export default config;